__turbopack_context__.v({
  "arc": "guG5zG_arc",
  "label": "guG5zG_label",
  "progressCircleSpin": "guG5zG_progressCircleSpin",
  "root": "guG5zG_root",
  "svg": "guG5zG_svg",
  "track": "guG5zG_track",
});
